<template>
  <div class="search">
    <div class="center">
      <div class="logo">
        <router-link to="/index"
          ><img src="@/assets/images/logo2.png"
        /></router-link>
      </div>
      <router-link to="/index" class="biaoyus">
        <div style="color: #cfe2ff;">高速ETC办理中心</div>
        <!-- 跨度 -->
        <!-- <p>www.etccenter.com</p> -->
        <p>www.etczx.com</p>
      </router-link>
      <div class="nav">
        <a id="diyi" @click.prevent="Tocontone" class="visited">首页</a>
        <a id="dier" @click.prevent="Toconttwo">ETC营业厅</a>
        <!-- <a
          id="diliu"
          target="_blank"
          href="https://shop93137571.m.youzan.com/v2/feature/mymxER4Oo3?ps=760"
          >车品商城</a
        > -->
        <!-- <a id='disan' @click.prevent="Tocontthree" >产品介绍</a> -->
        <a id="disan" @click.prevent="Tocontthree">平台优势</a>
        <a id="disi" @click.prevent="Tocontfour">常见问题</a>
        <a id="diwu" @click.prevent="Tocontfive">关于我们</a>
      </div>
    </div>
  </div>
</template>
<script>
// import { scrollAnimation } from "../../../static/utils.js";
import { mapState, mapMutations } from "vuex";
export default {
  props: ["headers"],
  data() {
    return {
      currentPath: "/index",
      fromPath: "",
      canScroll:true,
      windowHeight:0,
      documentHeight:0,
      scrollTop:0,
      unms:1


    };
  },

  mounted() {
    // console.log(
    //     this.props.uesr
    // )
  },
  computed: {
    // ...mapState({
    //   canScroll: state => state.header.canScroll,
    //   current: state => state.header.current
    // })
  },
  watch: {
   
    $route(to, from) {
      console.log("从" + from.path);
      console.log("去" + to.path);
      this.currentPath = to.path;
      this.changeCurrentPath(this.currentPath);
      // if(this.currentPath === '/onLineHandle' || this.currentPath === '/searchAccount' || this.currentPath === '/searchOrder') {
      if (
        this.currentPath === "/onLineHandle" ||
        this.currentPath === "/onLineHandle_truck"
      ) {
        console.log("guolai 第二个了");
        // document.getElementById("dier").click();
        $("#dier")
          .addClass("visited")
          .siblings()
          .removeClass("visited");
      } else if (this.currentPath === "/productDescription") {
        console.log("guolai 第三个了");
        // document.getElementById("disan").click();
        $("#disan")
          .addClass("visited")
          .siblings()
          .removeClass("visited");
      } else if (
        this.currentPath === "/commonQuestion/questionDetailInfo" ||
        this.currentPath === "/commonQuestion/questionList"
      ) {
        console.log("这是问题页面");
        // document.getElementById("disi").click();
        $("#disi")
          .addClass("visited")
          .siblings()
          .removeClass("visited");
      } else if (this.currentPath === "/aboutUs") {
        console.log("这是关于页面");
        // document.getElementById("diwu").click();
        $("#diwu")
          .addClass("visited")
          .siblings()
          .removeClass("visited");
      } else if (this.currentPath === "/index") {
        $("#diyi")
          .addClass("visited")
          .siblings()
          .removeClass("visited");
      }
    }
  },
  methods: {
    ...mapMutations([
      // "changeScrollStatus",
      "changeCurrent",
      "changeCurrentPath"
    ]),
    scrollAnimation (targetPageY) {
    var that = this
    var timer=null;
    clearInterval(timer);
     timer = setInterval(function () {
        var currentY = document.documentElement.scrollTop || document.body.scrollTop;//当前及滑动中任意时刻位置
        var distance = targetPageY > currentY ? targetPageY - currentY : currentY - targetPageY;//剩余距离
        var speed = Math.ceil(distance/10);//每时刻速度
        if (((targetPageY-currentY)<=10&&(targetPageY-currentY)>=-10)||(targetPageY==currentY)) {
            clearInterval(timer);
            that.canScroll = true
        } else {
            window.scrollTo(0,targetPageY > currentY ? currentY + speed : currentY - speed);
        }
    },10);
   
    window.addEventListener("scroll", function(event)
    {
        event = event || window.event;
        var scrollTop = $(this).scrollTop(); 
        that.scrollTop = scrollTop
        var documentHeight = $(document).height(); 
        that.documentHeight = documentHeight
        var windowHeight = $(window).height();
        that.windowHeight = windowHeight
        // console.log(scrollTop + windowHeight) 
        let num = that.detectZoom()
        that.unms = num
        if(num == 0.8){
            if (scrollTop + windowHeight == documentHeight-0.25){
              that.canScroll = true
                clearInterval(timer);
           
                
            }
        }else{
            if (scrollTop + windowHeight == documentHeight){
              that.canScroll = true
                clearInterval(timer);
               
            }
        }
       
    });
},
 detectZoom(){ 
    var ratio = 0,
      screen = window.screen,
      ua = navigator.userAgent.toLowerCase();
     if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    else if (ua.indexOf('msie')) {  
      if (screen.deviceXDPI && screen.logicalXDPI) {
        ratio = screen.deviceXDPI / screen.logicalXDPI;
      }
    }
    else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      ratio = window.outerWidth / window.innerWidth;
    }
     
     if (ratio){
      ratio = Math.round(ratio * 100);
    }
     return ratio/100;
  },
    Tocontone() {
      if (this.currentPath === "/index") {
        if (this.canScroll) {
          // this.changeScrollStatus();
         this.canScroll = false
          // this.canScroll = false;
          // const div = document.getElementById('index');
          // const height = div.offsetTop - 80;
          const height = localStorage.getItem("indexHeight");
          // scrollAnimation(height, this.changeScrollStatus);
          this.scrollAnimation(height);
          // console.log(height);

          // window.scrollTo(height);
          // setTimeout(() => {
          //     this.changeScrollStatus();
          // },800)
          // document.querySelector("#index").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
      } else {
        this.$router.push({ name: "Home" });
      }
    },
    Toconttwo() {
      if (this.currentPath === "/index") {
        if (this.canScroll) {
          this.canScroll = false
          // this.changeScrollStatus();
          // const div = document.getElementById('online');
          // const height = div.offsetTop - 80;
          const height = localStorage.getItem("lineHeight");
          // scrollAnimation(height, this.changeScrollStatus);
          this.scrollAnimation(height);
          // console.log(height);
          // setTimeout(() => {
          //     this.changeScrollStatus();
          // },800)
          // window.scroll(0,height);
          // scrollAnimation(height)
          // document.querySelector("#online").scrollIntoView(true);
          // document.querySelector("#online").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
      } else {
        this.$router.push({ name: "Home", params: { number: 2 } });
      }
    },
    Tocontthree() {
      if (this.currentPath === "/index") {
        if (this.canScroll) {
          this.canScroll = false
          // this.changeScrollStatus();
          // const div = document.getElementById('chanpin');
          // const height = div.offsetTop - 80;
          const height = localStorage.getItem("chanpinHeight");
          // scrollAnimation(height, this.changeScrollStatus);
          this.scrollAnimation(height);
          // console.log(height);
          // setTimeout(() => {
          //     this.changeScrollStatus();
          // },800)
          // window.scrollTo(0,height);
          // scrollAnimation(height)
          // document.querySelector("#chanpin").scrollIntoView(true);
          // document.querySelector("#chanpin").scrollIntoView({behavior: "smooth", block: "start", });
        }
      } else {
        this.$router.push({ name: "ProductDes" });
        // this.$router.push({name: 'Home'});
      }
    },
    Tocontfour() {
      if (this.currentPath === "/index") {
        if (this.canScroll) {
          this.canScroll = false
          // this.changeScrollStatus();
          // const div = document.getElementById('wenti');
          // const height = div.offsetTop - 80;
          const height = localStorage.getItem("wentiHeight");
          // scrollAnimation(height, this.changeScrollStatus);
          this. scrollAnimation(height);
          // console.log(height);
          // setTimeout(() => {
          //     this.changeScrollStatus();
          // },800)
          // console.log(height)
          // window.scrollTo(0,height);
          // scrollAnimation(height)
          // document.querySelector("#wenti").scrollIntoView(true);
          // document.querySelector("#wenti").scrollIntoView({behavior: "smooth", block: "start", });
        }
      } else {
        this.$router.push({ name: "QuestionDetailInfo" });
      }
    },
    Tocontfive() {
      if (this.currentPath === "/index") {
     
        if(this.unms == 0.8){
            if (this.scrollTop + this.windowHeight != this.documentHeight-0.25){
            
              if (this.canScroll) {
          this.canScroll = false
          // this.changeScrollStatus();
          // const div = document.getElementById('guanyu');
          // const height = div.offsetTop - 120;d
          const height = localStorage.getItem("guanyuHeight");
          // scrollAnimation(height, this.changeScrollStatus);
          this.scrollAnimation(height);
          // console.log(height);
          // setTimeout(() => {
          //     this.changeScrollStatus();
          // },800)
          // console.log(height)
          // window.scrollTo(0,height);
          // scrollAnimation(height)
          // document.querySelector("#guanyu").scrollIntoView(true);
          // document.querySelector("#guanyu").scrollIntoView({behavior: "smooth", block: "start", });
        }
                
            }
        }else{
            if (this.scrollTop + this.windowHeight != this.documentHeight){
              if (this.canScroll) {
          this.canScroll = false
          // this.changeScrollStatus();
          // const div = document.getElementById('guanyu');
          // const height = div.offsetTop - 120;d
          const height = localStorage.getItem("guanyuHeight");
          // scrollAnimation(height, this.changeScrollStatus);
          this.scrollAnimation(height);
          // console.log(height);
          // setTimeout(() => {
          //     this.changeScrollStatus();
          // },800)
          // console.log(height)
          // window.scrollTo(0,height);
          // scrollAnimation(height)
          // document.querySelector("#guanyu").scrollIntoView(true);
          // document.querySelector("#guanyu").scrollIntoView({behavior: "smooth", block: "start", });
        }
               
            }
        }
        
      } else {
        this.$router.push({ name: "AboutUs" });
      }
    }
    // Tocontsix(){

    // }
  },
  mounted() {
    $(".nav a").on("click", function() {
      $(this)
        .addClass("visited")
        .siblings()
        .removeClass("visited");
    });
  }
};
</script>
<style lang="scss" scoped>
@import "./css/index.scss";
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue